import { type ISettingValueMaster } from "@bbj-types/setting";
import tinymce from "tinymce/tinymce";
import { getSettingsByValues } from "@api";

tinymce.PluginManager.add("variables_list", function (editor) {
  let variablesList: ISettingValueMaster[] = [];
  editor.ui.registry.addAutocompleter("autocompleter-variables", {
    ch: "[", // the trigger character to open the autocompleter
    minChars: 0, // lower number means searching sooner - but more lookups as we go
    columns: 1, // must be 1 for text-based results
    fetch: function (pattern) {
      return new Promise(async (resolve) => {
        variablesList = await getSettingsByValues("template_variable", "status", pattern);
        let results = variablesList.map((val) => ({
          value: val.value,
          text: val.label,
        }));

        // sort results by the "name"
        results.sort(function (a, b) {
          let x = a.text.toLowerCase();
          let y = b.text.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });

        // resolve the initial promise
        resolve(results);
      });
    },
    onAction: function (autocompleteApi, rng, value) {
      // split the value in to two parts - the name and the flag URL
      // we joined it above using a pipe (|)
      const item = variablesList.find((v) => v.value === value);
      if (item) {
        editor.fire("SelectVariable", item);
        // insert in to the editor
        editor.selection.setRng(rng);
        editor.insertContent(`[[${item.label}]]`);
      }

      // hide the autocompleter
      autocompleteApi.hide();
    },
  });

  return {
    getMetadata: function () {
      return {
        name: "Liste des Variables Plugin",
        url: "http://exampleplugindocsurl.com",
      };
    },
  };
});
